module.exports = __webpack_public_path__ + "static/media/top-millionaires-light-icon.b8bb4a22.svg";